
const BackEndBase = "https://api.association-iaicongo.org";
const BackEndAPIBase = BackEndBase + "/api/v1";
const APIMembers = "/members";
const APIPayments = "/payments";
const APIAuth = "/auth";
let Route = {
    // Public Front
    Home: {
        link: "/",
        label: "Accueil"
    },
    Association: {
        link: "/association",
        label: "L'association"
    },
    Activities: {
        link: "/activities",
        label: "Activités"
    },
    Directory: {
        link: "/directory",
        label: "Annuaire"
    },
    News: {
        link: "/news",
        label: "Actualités"
    },
    Contact: {
        link: "/contact",
        label: "Contact"
    },
    Forum: {
        link: "/forum",
        label: "Forum"
    },
    Join: {
        link: "/join",
        label: "Adhérer"
    },
    SignIn: {
        link: "/sign-in",
        label: "Se connecter"
    },
    PasswordForgotten: {
        link: "/password-forgotten",
        label: "Mot de passe oublié"
    },
    Logout: {
        link: "/logout",
        label: "Se déconnecter"
    },
    Proof: {
        link: "/proof/:proof_token",
        label: "Justificatif"
    },
    PaySession: {
        link: "/pay-session/:token",
        label: "Paiement MoMo"
    },
    PaySessionSuccessful: {
        link: "/payment-successful/:purchaseToken",
        label: "Paiement MoMo"
    },
    Administration: {
        link: "/admin",
        label: "Administration"
    },
    MemberProfile: {
        link: "/member-profile",
        label: "Espace membre"
    },
    MemberProfileSpecificRoute: {
        link: "/member-profile/:page",
        label: "Espace membre"
    },
    APIBaseUrl: BackEndAPIBase,

    APIMembers: APIMembers + "/",
    APIMembersProfile: APIMembers + "/",
    APIMembersProfileEditEmailPwd: APIMembers + "/change-email-or-password/{idOrAccessToken}",
    APIMembersContact: APIMembers + "/contact",
    APIMembersAccounts: APIMembers + "/accounts",
    APIMembersAccountsCreate: APIMembers + "/accounts/{id}",
    APIMembersAccountsLock: APIMembers + "/accounts/{id}/lock",
    APIMembersAccountsReset: APIMembers + "/accounts/{id}/reset",
    APIPaymentsContributionsFormDataCreate: APIPayments + "/contribution-create-form",
    APIPaymentsContributionsFormDataSave: APIPayments + "/contribution-save-form",
    APIPaymentsContributions: APIPayments + "/contributions",
    APIPaymentsContributionsRelaunchMail: APIPayments + "/contributions/{id}/relaunch-mail",
    APIPaymentsContributionsCreate: APIPayments + "/contributions",
    APIPaymentsContributionsSave: APIPayments + "/contributions/save",
    APIPaymentsContributionsFutures: APIPayments + "/contributions/futures",
    APIMembersContributionsPaid: APIMembers + "/{memberId}/contributions/paid",
    APIMembersContributionsNotPaid: APIMembers + "/{memberId}/contributions/not-paid",
    APIPaymentsLaunchMobileMoneyContribution: APIPayments + "/contributions/{contributionId}/contributor/{contributorId}",
    APIPaymentsCheckPaySession: APIPayments + "/check-pay-session/{token}",
    APIPaymentsCheckPaySessionSuccessful: APIPayments + "/check-pay-session-successful/{purchaseToken}",
    APIUploadMemberFile: APIMembers + "/upload-file",
    APILoadMemberFile: APIMembers + "/display-file/",
    APISetMemberProof: APIMembers + "/proof/:proof_token",
    APIMembersFormData: APIMembers + "/form-data",
    APIMembersEditFormData: APIMembers + "/edit-form-data",
    APIMembersDashboard: APIMembers + "/dashboard",
    APIMembersApplications: APIMembers + "/applications",
    APIMembersAuthLogin: APIAuth + "/login",
    APIMembersAuthLogout: APIAuth + "/logout",
    APIMembersAuthPasswordForgotten: APIAuth + "/password-forgotten",
    APIMembersReports: APIMembers + "/reports",
    APIMembersAssociationTexts: APIMembers + "/association-texts",
    APIDownloadFile: {
        status : BackEndBase + "/display-file/status",
        procedureRules : BackEndBase + "/display-file/rules-procedure",
    },
};

export default Route;